export const PROPERTY_INSTRUCTION_CATEGORIES = {
    "HOUSE_RULE": "house_rule",
    "WIFI": "wifi",
}